import { DescriptionSection } from "./description";
export function BlogPage() {
  return (
    <main class="w-screen">
      <DescriptionSection />
    </main>
  );
}
